import { Inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import * as fromGraphQl from './graphql';
import { Group } from '../../entities/group/group';
import { NXDataSourcePrime } from '../../services/dataSource/NXDataSourcePrime';

export class GroupDataSource extends NXDataSourcePrime<Group> {
  constructor(
    apollo: Apollo,
    @Inject('env') environment : any
    ) {
    super(apollo, fromGraphQl.GROUPS_QUERY, environment);
  }
  handleSubscriptionResult(data: fromGraphQl.GroupsQueryResponse): void {
    super.setSubject(
      data.groups?.content ? data.groups?.content : [],
      data.groups?.totalElements ? data.groups.totalElements : 0
    );
  }

  loadUsers(variables: any): void {
    this.querySubscription?.unsubscribe();
    this.subscribeToQuery(variables);
  }
}
